
import hero from "../assets/images/hero.webp";
import playstore from "../assets/images/play store.png";
import appstore from "../assets/images/app store.png";

export default function Hero() {
  return (
    <div>
      <div className="container xl:mt-[200px] mt-40 max-sm:mt-20 ">
        <div className="lg:flex gap-10 ">
          <div className="flex-1">
            <h1>Your Personal AI Lecturer</h1>
            <p className="mt-2 mb-10 xl:mb-16">
              #NoMoreCarryOver
            </p>
            <div className="flex gap-10 mb-12">
              <button>
                <img src={appstore} alt="apple" width={"200px"}/>
              </button>
              <button>
                <img src={playstore} alt="play" width={"200px"}/>
              </button>
            </div>
          </div>
          <div className="flex-1 lg:justify-items-end ">
            <img src={hero} alt="hero-img" />
          </div>
        </div>
      </div>
    </div>
  );
}
